import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { Radio } from 'tea-component';
import { Relation } from '@intelligence/components/GenreSelect/enums';
import TipContext from '@home/components/TipContextComponents/TipContext';
import type { CheckChangeContext } from 'tea-component';
import type { IBaseProps } from '@intelligence/components/GenreSelect/types';

import '@intelligence/components/GenreSelect/components/RelationSelect/index.scss';

interface IRelationSelectProps extends IBaseProps {
  value?: Relation;
  onChange?: (payload: Relation, context?: CheckChangeContext) => void;
}

const RelationSelect: React.FC<IRelationSelectProps> = (props) => {
  const { style, className, value, onChange } = props;

  const { formatMessage } = useIntl();

  return (
    <div style={style} className={classnames('panel-relation', className)}>
      <div className="panel-relation-andor-tips">
        <span>{formatMessage({ id: `dbi_choose_andor_for` })}</span>
        <TipContext
          className="card-slot-v2-right-tip"
          tipText={formatMessage({ id: `dbi_choose_andor_for_tips` })}
        />
      </div>
      <Radio.Group
        className="panel-relation-radio-group"
        value={value}
        onChange={(payload, context) => {
          onChange?.(payload as Relation, context);
        }}
      >
        <Radio name={Relation.And}>{formatMessage({ id: `dbi_genre_and` })}</Radio>
        <Radio name={Relation.Or}>{formatMessage({ id: `dbi_genre_or` })}</Radio>
      </Radio.Group>
    </div>
  );
};

export default RelationSelect;
